<template>
  <div class="main">
    <div class="header">
      <div class="back" @click="goBack">
        <img :src="backImage" />
      </div>
    </div>
    <div class="body" :style="background">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import back from "../../assets/dkleech.png";
import image from "../../assets/leechbg.png";

import router from "../../router";

export default {
  data() {
    return {
      backImage: back,
    };
  },
  methods: {
    goBack() {
      router.push("/forum");
    },
  },
  computed: {
    background() {
      return {
        backgroundImage: 'url("' + image + '")',
        backgroundColor: "#ffdff2",
        backgroundSize: "100px",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;

  .header {
    position: absolute;
    top: 0;
    left: 0;
    height: 60px;
    padding: 5px;
    box-sizing: border-box;
    width: 100%;
    z-index: 1000;
    background-color: #ffffff;
    box-shadow: 0 3px 5px #999999;
    display: flex;
    justify-content: space-between;

    .back {
      border-radius: 50%;
      width: 50px;
      height: 50px;
      box-sizing: border-box;
      padding: 5px;
      cursor: pointer;
      background-color: #444444;

      img {
        height: 40px;
        width: 40px;
      }
    }
  }

  .body {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 100px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}
</style>
